module.exports = __webpack_public_path__ + "media/images/profile/family-info-183cb08c8234804289fbf0b68be1222c.svg";